<template>
    <transition name="fade">
        <template v-if="view == 'grid'">
            <div @click="goToFolder"
                 ref="card"
                 :loading="loading"
                 class="relative flex flex-wrap justify-center border border-lg border-grey-lighter overflow-hidden px-0 py-0 cursor-pointer">

                <template v-if="loading">
                    <div class="rounded-lg flex items-center justify-center absolute pin z-50">
                        <app-loader />
                    </div>
                </template>

                <svg class="text-5xl text-grey w-2/3 h-5/6" aria-hidden="true" data-prefix="fal" data-icon="folder" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg=""><path fill="currentColor" d="M194.74 96l54.63 54.63c6 6 14.14 9.37 22.63 9.37h192c8.84 0 16 7.16 16 16v224c0 8.84-7.16 16-16 16H48c-8.84 0-16-7.16-16-16V112c0-8.84 7.16-16 16-16h146.74M48 64C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48H272l-54.63-54.63c-6-6-14.14-9.37-22.63-9.37H48z"></path></svg>


                <div class="h-1/6 w-full text-center text-xs  border-t border-30 bg-50 flex items-center justify-center">
                    {{ file.name }}
                </div>

            </div>
        </template>

        <template v-else>
            <div @click="goToFolder" ref="card" :loading="loading" class="relative flex flex-wrap items-center border border-grey-lighter overflow-hidden px-0 py-0 cursor-pointer">

                <div class="text-center px-3">
                    <template v-if="loading">
                        <div class="rounded-lg flex items-center justify-center absolute pin z-50">
                            <app-loader />
                        </div>
                    </template>

                    <svg class="text-2xl text-grey w-10" aria-hidden="true" data-prefix="fal" data-icon="folder" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg=""><path fill="currentColor" d="M194.74 96l54.63 54.63c6 6 14.14 9.37 22.63 9.37h192c8.84 0 16 7.16 16 16v224c0 8.84-7.16 16-16 16H48c-8.84 0-16-7.16-16-16V112c0-8.84 7.16-16 16-16h146.74M48 64C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48H272l-54.63-54.63c-6-6-14.14-9.37-22.63-9.37H48z"></path></svg>
                </div>

                <div class="flex-grow px-3">
                    {{ file.name }}
                </div>
            </div>
        </template>
    </transition>
</template>

<script>
import Loader from '@/components/Loader';

export default {
    components: {
        'app-loader': Loader,
    },

    props: {
        file: {
            type: Object,
            default: function() {
                return { name: '' };
            },
            required: true,
        },
        view: {
            type: String,
            default: 'grid',
        },
    },

    data: () => ({
        loading: true,
        missing: false,
    }),

    mounted() {
        this.loading = false;
    },

    methods: {
        goToFolder() {
            this.$emit('goToFolderEvent', this.file.path);
        },
    },
};
</script>

<style scoped  lang="scss">
.card {
    padding: 0 !important;

    &:hover {
        > svg {
            opacity: 0.5;
        }
    }
}

.h-5\/6 {
    height: 83.33333%;
}

.h-1\/6 {
    height: 16.66667%;
}

.h-2\/3 {
    height: 75%;
}
</style>



// WEBPACK FOOTER //
// src/components/filemanager/modules/Folder.vue